<script lang="ts">
  import { DropdownMenu as DropdownMenuPrimitive } from "bits-ui";
  import { cn, flyAndScale } from "@/helpers/tw-utils";

  type $$Props = DropdownMenuPrimitive.ContentProps;

  interface Props {
    class?: $$Props["class"];
    sideOffset?: $$Props["sideOffset"];
    children?: import("svelte").Snippet;
    [key: string]: any;
  }

  let {
    class: className = undefined,
    sideOffset = 4,
    transition = flyAndScale,
    transitionConfig = undefined,
    children,
    ...rest
  }: Props = $props();
</script>

<DropdownMenuPrimitive.Content
  {sideOffset}
  class={cn(
    "z-50 min-w-[8rem] rounded-md border bg-popover p-1 text-popover-foreground shadow-md focus:outline-none",
    className
  )}
  {...rest}>
  {@render children?.()}
</DropdownMenuPrimitive.Content>
